import { cn } from '@/lib/utils'
import { Loader2 } from 'lucide-react'

export function FullPageSpinner({ className }: { className?: string }) {
  return (
    <main className="flex h-screen w-screen items-center justify-center">
      <Loader2 className={cn('h-16 w-16 animate-spin ', className)} />
    </main>
  )
}

export function MaxSizeSpinner({ className }: { className?: string }) {
  return (
    <div className="flex h-max w-full items-center justify-center">
      <Loader2 className={cn('h-16 w-16 animate-spin ', className)} />
    </div>
  )
}

export function SmallSpinner({ className }: { className?: string }) {
  return <Loader2 className={cn('h-4 w-4 animate-spin ', className)} />
}
